// Create our number formatter.
export const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export function convertCentsToDisplayPrice(cents: number): string {
    const centsNumber = Number(cents);
    const dollars = centsNumber / 100;
    return currency.format(dollars);
}

export function convertCents(cents: number): number {
    return cents / 100;
}

export const currencyWithoutCents = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const compactCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact', // Use compact notation for K, M, B suffixes
    compactDisplay: 'short', // Use short form (e.g., 'K' instead of 'thousand')
    maximumFractionDigits: 1, // Adjust as needed for decimal places
});
